import {Map, fromJS, List} from "immutable";

import {
    GET_MATERIALS_SUCCESS,
    GET_MATERIALS_REQUEST,
    GET_MATERIALS_ERROR,

    GET_MATERIAL_REQUEST,
    GET_MATERIAL_SUCCESS,
    GET_MATERIAL_ERROR,

    CREATE_MATERIAL_REQUEST,
    CREATE_MATERIAL_SUCCESS,
    CREATE_MATERIAL_ERROR,

    UPDATE_MATERIAL_REQUEST,
    UPDATE_MATERIAL_SUCCESS,
    UPDATE_MATERIAL_ERROR,

    DELETE_MATERIAL_REQUEST,
    DELETE_MATERIAL_SUCCESS,
    DELETE_MATERIAL_ERROR,

    CLEAN_MATERIALS
} from '../actions/materials';

const materials = (state = Map({
  payload: List([]),
  isFetching: false,
  error: false
}), action) => {
  let newState, updatedPayload, index, payload = state.get('payload');
  switch (action.type) {

      // Requests
      case GET_MATERIALS_REQUEST:
      case GET_MATERIAL_REQUEST:
      case CREATE_MATERIAL_REQUEST:
      case UPDATE_MATERIAL_REQUEST:
      case DELETE_MATERIAL_REQUEST:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Success
      case GET_MATERIALS_SUCCESS:
      case GET_MATERIAL_SUCCESS:
      case CLEAN_MATERIALS:
          newState = state.merge({
              payload: fromJS(action.payload),
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      case CREATE_MATERIAL_SUCCESS:
          // Check if payload is a List (Array)
          if(List.isList(payload)) {
              updatedPayload = payload.push(fromJS(action.payload));

              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(payload)) {
              updatedPayload = fromJS(action.payload);
          }

          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              created: action.created,
              payload: updatedPayload
          });
          return newState;

      case UPDATE_MATERIAL_SUCCESS:

          // Check if payload is a List (Array)
          if(List.isList(payload)) {

              // Find the index of the work-report to be updated inside the List
              index = payload.findIndex(item => {
                  return item.get('_id') === action.payload._id;
              });

              // Update the payload list
              if (index !== -1) {
                  updatedPayload = payload.update(index, () => {
                      return fromJS(action.payload);
                  });
              }


              // If payload is a Map the payload to be updated is action.payload itself
          } else if(Map.isMap(state.get('payload'))) {
              updatedPayload = fromJS(action.payload);
          }
          newState = state
              .merge({
                  isFetching: action.isFetching,
                  error: action.error,
                  updated: action.updated,
                  payload: updatedPayload
              });
          return newState;
      case DELETE_MATERIAL_SUCCESS:
          updatedPayload = payload.filter( workReport => {
              return workReport.get('_id') !== action.payload._id;
          });
          newState = state.merge({
              payload: updatedPayload,
              isFetching: action.isFetching,
              error: action.error
          });
          return newState;

      // Errors
      case GET_MATERIALS_ERROR:
      case GET_MATERIAL_ERROR:
      case CREATE_MATERIAL_ERROR:
      case UPDATE_MATERIAL_ERROR:
      case DELETE_MATERIAL_ERROR:
          newState = state.merge({
              isFetching: action.isFetching,
              error: action.error,
              errorMessage: action.errorMessage
          });
          return newState;
      default:
          return state;
  }
};

export default materials;



// WEBPACK FOOTER //
// ./src/reducers/materials.js